// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__3lF6T","modalFooterButton":"ModalNotes_modalFooterButton__3stcH"};